import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                        <div className="consider_content">
                                <h2>When To Consider Our Enterprise App Development Services</h2>
                               <p>We provide extensive enterprise app solutions customized to suit the specific requirements of businesses, ranging from startups to large enterprises.</p>
                               <p>Here’s when you should consider TekRevol for your enterprise mobile app development services:</p> 
                               <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Build Your Enterprise App</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
                    <div className="consider-box">
                        <h6>When You Need Scalable Solutions</h6>
                        <p>If your business is on the path to expansion and requires scalable solutions to accommodate growth, our enterprise app development services are tailored to meet your evolving needs.</p>
                    </div>
                    <div className="consider-box">
                        <h6>When Efficiency Is a Priority</h6>
                        <p>Consider our services when you're looking to optimize and streamline your business processes, enhancing overall efficiency and productivity.</p>
                    </div>
                    <div className="consider-box">
                        <h6>When Data Security Is Non-Negotiable</h6>
                        <p>If the security of your business data is a top concern, our enterprise app development incorporates robust security features to safeguard your valuable information.</p>
                    </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Considerapp